// Version for BK. Keep in sync with other brands if needed
export const version = {
  // Updating this will cause the region/lang modal to be shown on multi-lang regions
  localStorage: 9,

  cookie: 1,
};
